import Enlang from "./entries/en-US";
import PtLang from "./entries/pt-BR";
import EsLang from "./entries/es-ES";
import { addLocaleData } from "react-intl";

const AppLocale = {
  en: Enlang,
  pt: PtLang,
  es: EsLang
};

addLocaleData([
  ...Enlang.data,
  ...PtLang.data,
  ...EsLang.data
]);

export default AppLocale;
